require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-oberwart-bad-tatzmannsdorf.json") })
        }
      }, "path---betreuungseinrichtungen-oberwart-bad-tatzmannsdorf");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-oberwart-bad-tatzmannsdorf!./.cache/json/betreuungseinrichtungen-oberwart-bad-tatzmannsdorf.json
// module id = 1000
// module chunks = 231608221292675